import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "@i18n";
import { Link, useParams } from "react-router-dom";
import { qs } from "url-parse";
import Layout from "@/_LayoutsRelated/layout/Layout";
import Button from "../../../components/UiKit/Button/Button";
import Disclaimer from "@/_MiniApps/Disclaimer/Disclaimer";
import stl from "./PreCheckout.module.css";
import { cashCheckout1Event, finanaceButtonClickedEvents } from "@/utils/dataLayerEvents";
import PaymentInfo from "@/pages/checkout/components/PaymentInfo/PaymentInfo";
import { trackEvents } from "@/common/events/events";
import { useIsMobile } from "@/common/Contexts/IsMobileContext";
import CancelButton from "../../../components/UiKit/Buttons/CancelButton/CancelButton";
import useHelpers from "@hooks/useHelpers";
import Loader from "@componentsShared/Loader/Loader";
import { PURCHASE_METHOD_AMWAL, PURCHASE_METHOD_ARIB, PURCHASE_METHOD_CASH, PURCHASE_METHOD_NORMAL_FINANCE, PURCHASE_METHOD_TABBY, PURCHASE_METHOD_TAMRA, useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import PreCheckoutMainForm from "@/pages/checkout/pre-checkout/PreCheckoutMainForm";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { CDN_LINK } from "@globalConfig";
import useBoolean from "@hooks/useBoolean";
import PreCheckoutFAQs from "@/pages/checkout/pre-checkout/PreCheckoutFAQs";
import useSticky from "@hooks/useSticky";
import { twMerge } from "tailwind-merge";
import { useSession } from "@/_MiniApps/auth/AuthContext";
var PreCheckout = function PreCheckout() {
  if (__IS_SSR__) return /*#__PURE__*/React.createElement(Loader, null);
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateBack = _useHelpers.navigateBack,
    navigateToHard = _useHelpers.navigateToHard;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  var _useParams = useParams(),
    post_id = _useParams.postId;
  var _useState = useState(null),
    event = _useState[0],
    setEvent = _useState[1];
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrder = _useCheckoutOrder$sta.checkoutOrder,
    fetch_loading = _useCheckoutOrder$sta.fetch_loading,
    showCampaignModal = _useCheckoutOrder$sta.showCampaignModal;
  var purchaseMethod = useCheckoutOrder().state.purchaseMethod;
  var fetch__getOrderWithPaymentInfo = useCheckoutOrder().remote_actions.fetch__getOrderWithPaymentInfo;
  var _useCheckoutOrder$act = useCheckoutOrder().actions,
    action__setPurchaseMethod = _useCheckoutOrder$act.action__setPurchaseMethod,
    action__setShowCampaignModal = _useCheckoutOrder$act.action__setShowCampaignModal;
  var grantedPopup = useBoolean();
  var _useHelpers2 = useHelpers(),
    createUrl = _useHelpers2.createUrl;
  var _useSession = useSession(),
    user = _useSession.user;
  var stickyRef = useRef(null);
  var isComponentSticky = useSticky(stickyRef);
  useEffect(function () {
    fetch__getOrderWithPaymentInfo(Number(post_id));
  }, [post_id]);
  var handleContinue = function handleContinue() {
    switch (purchaseMethod) {
      case PURCHASE_METHOD_CASH:
        return navigateTo("/checkout/shop-apply?post_id=".concat(post_id));
      case PURCHASE_METHOD_NORMAL_FINANCE:
        return navigateTo("/finance-apply-free/".concat(post_id, "?").concat(qs.stringify({
          financestep: 1
        })));
      case PURCHASE_METHOD_TAMRA:
        return navigateTo("/finance-apply-tamara?post_id=".concat(post_id));
      case PURCHASE_METHOD_ARIB:
        return navigateTo('/finance-apply-arib', {
          post_id: post_id
        });
      case PURCHASE_METHOD_TABBY:
        return navigateTo("/finance-apply-tabby?post_id=".concat(post_id));
      case PURCHASE_METHOD_AMWAL:
        return navigateTo("/finance-apply-amwal?post_id=".concat(post_id));
      default:
        return;
    }
  };
  return /*#__PURE__*/React.createElement(Layout, {
    hideBurgerMenu: isMobile,
    hideFooter: true,
    hideOrangeHeadBtn: true,
    headHideLinks: true,
    hideAppBanner: true,
    straightHeader: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement("div", {
      className: stl.mobileHeader
    }, /*#__PURE__*/React.createElement("strong", {
      className: "!text-black-primary text-center"
    }, tShort("pre-checkout/mobile_page_title", {
      ns: "web_pre_checkout"
    })), /*#__PURE__*/React.createElement(CancelButton, {
      isArrow: true,
      onClick: navigateBack,
      className: "".concat(stl.CancelButton, " !text-primary-new")
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.container, " container")
  }, isMobile && /*#__PURE__*/React.createElement("div", {
    className: stl.mobileCarName
  }, /*#__PURE__*/React.createElement("strong", {
    className: ""
  }, fetch_loading && /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24,
    divWidth: 150
  }), /*#__PURE__*/React.createElement(Link, {
    id: "precheckout-car-name",
    to: createUrl("/cardetail/".concat(post_id)),
    className: "font-bold text-sm text-gray-text underline hover:text-gray-text"
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_title)), /*#__PURE__*/React.createElement("strong", null, fetch_loading && /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24,
    divWidth: 80
  }), !fetch_loading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "precheckout-car-price",
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-bold text-gray-text text-1.5xl"
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.sale_price), /*#__PURE__*/React.createElement("span", null, t("sar", {
    ns: "web_common"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: stl.flxContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.subBox
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid lg:w-[664px] lg:shadow-[0_0px_10px_rgb(188,188,188,0.4)] lg:rounded-2xl lg:box-border lg:p-[42px] lg:bg-white md:!pt-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.title, 'hidden md:block md:!mb-6 text-black-primary text-xl'].join(" ")
  }, t("choose_purchase_method", {
    ns: "web_pre_checkout"
  })), /*#__PURE__*/React.createElement(PreCheckoutMainForm, null), isMobile && /*#__PURE__*/React.createElement(PreCheckoutFAQs, null), /*#__PURE__*/React.createElement("div", {
    ref: stickyRef,
    className: twMerge("sticky bottom-0 left-0 bg-white p-4 rounded-lg w-auto mx-[-16px] md:relative md:p-0 md:rounded-none md:mx-0", isComponentSticky ? "shadow-[0px_0px_12px_0px_rgba(0,0,0,0.15)] md:shadow-none" : "shadow-none")
  }, /*#__PURE__*/React.createElement(Button, {
    id: "precheckout-proceed-btn",
    onClick: function onClick() {
      var _checkoutOrder$g4_dat, _checkoutOrder$g4_dat2;
      var booking_type = null;
      if (purchaseMethod === PURCHASE_METHOD_CASH) {
        booking_type = "cash";
      } else if (purchaseMethod === PURCHASE_METHOD_NORMAL_FINANCE) {
        booking_type = "finance";
      } else if (purchaseMethod === PURCHASE_METHOD_ARIB) {
        booking_type = 'finance';
      } else if (purchaseMethod === PURCHASE_METHOD_TAMRA) {
        booking_type = "tamara";
      } else if (purchaseMethod === PURCHASE_METHOD_TABBY) {
        booking_type = "tabby";
      } else if (purchaseMethod === PURCHASE_METHOD_AMWAL) {
        booking_type = "amwal";
      }
      trackEvents("checkout", _objectSpread(_objectSpread({}, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer), {}, {
        booking_type: booking_type,
        post_trim: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat === void 0 ? void 0 : _checkoutOrder$g4_dat.post_ext,
        from_finance_calculator: false,
        inventory_type_string: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat2 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat2 === void 0 ? void 0 : _checkoutOrder$g4_dat2.inventory_type_string
      }));
      if (event === "finance") {
        finanaceButtonClickedEvents(null, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data);
      } else {
        cashCheckout1Event("checkout_lead", checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data);
      }
      handleContinue();
    },
    className: stl.btn,
    isDisabled: !purchaseMethod
  }, t("next", {
    ns: "web_common"
  }))), !isMobile && /*#__PURE__*/React.createElement(PreCheckoutFAQs, null))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "m-show mt-10"
  }, /*#__PURE__*/React.createElement(Disclaimer, {
    className: stl.Disclaimer
  }))), isDesktop && /*#__PURE__*/React.createElement("div", {
    id: "precheckout-finance-info",
    className: stl.subBox2
  }, /*#__PURE__*/React.createElement(PaymentInfo, {
    checkoutOrder: checkoutOrder,
    loading: fetch_loading,
    onClickInfoIcon: grantedPopup.setTrue
  })))), isDesktop && /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: grantedPopup.value,
    onClose: grantedPopup.setFalse,
    containerClassName: "!z-[999999999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-8 p-[13px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/infoOrange.svg",
    width: "96px",
    height: "82px",
    alt: "icon"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-blue-indigo text-center text-[32px] font-bold leading-[32px]"
  }, t("shipping_cost_2", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-blue-indigo text-center font-[Cairo] text-[20px] font-semibold leading-[32px]"
  }, t("shipping_cost_determined_sales_representative", {
    ns: "web_checkout_cash"
  })))));
};
export default PreCheckout;